export enum SmsType {
  PAY_REQUEST = 1,
  PAY_REMINDER = 2,
}
